














	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
	import {AxiosError} from "axios";
	import OrderAutocompleteInput from "@/components/order/OrderAutocompleteInput.vue";
	import UserAutocompleteInput from "@/components/user/UserAutocompleteInput.vue";
	import Report from "@/models/report/Report";
	import ReportUpdate from "@/models/report/ReportUpdate";
  import AsiTextarea from "@/components/common/AsiTextarea";

	@Component({
		components: {
      AsiTextarea,
			UserAutocompleteInput,
			OrderAutocompleteInput,
			AsiDialogFormLayout,
			AsiDatePicker
		}
	})
	export default class ReportUpdateDialogAdditionalInfosAdministration extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public report!: Report;

		private model: ReportUpdate | null = null;

		public created(): void {
			this.setReportInternal();
		}

		@Emit('save')
		public save(event: Event): Event {
			return event;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.setReportInternal();
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		@Watch('report', {deep: true})
		private onReportChanged(): void {
			this.setReportInternal();
		}

		private setReportInternal(): void {
			if (this.model === null) {
				this.model = new ReportUpdate(this.report);
			} else {
				this.model.setDetailModel(this.report);
			}
		}

		private requestSave(event: Event): void {
			if (this.model === null) return;

			this.loading = true;
			this.$reportService.updateNotesAdministration(this.report.id, this.model.notesAdministration)
				.then(() => this.save(event))
				.catch((err: AxiosError) => {
					this.errors = err.response?.data;
				})
				.finally(() => {
					this.loading = false;
				});
		}

	}
